import {
  rightPaneContentAtom,
  rightPaneEnabledAtom,
  rightPaneExpandedAtom,
  rightPaneTitleAtom,
} from '@/components/right-pane/right-pane.state';
import { SelectionsSidebar as ClickhouseSelectionsSidebar } from '@/features/clickhouse-trends/components/selections-sidebar/selections-sidebar';
import { currentChartIdAtom as clickhouseCurrentChartIdAtom } from '@/features/clickhouse-trends/state/current-chart.state';
import { firstChartIdAtom as clickhouseFirstChartIdAtom } from '@/features/clickhouse-trends/state/trend-groups.state';
import { SelectionsSidebar } from '@/features/trends/components/selections-sidebar/selections-sidebar';
import { currentChartIdAtom } from '@/features/trends/state/current-chart.state';
import { firstChartIdAtom } from '@/features/trends/state/trend-groups.state';
import { useImplyReadingsEnabled } from '@/hooks/use-imply-readings-enabled';
import { jotaiStore } from '@/providers/jotai/jotai-store';
import UserStateAtoms from '@/state/user.state';
import { resolveFacilityFromParams } from '@/utils/facility-resolver';

type TrendsRouteParams = { org: string; agent: string };

/**
 * Reactive right-pane content for the trends/reports routes. Picks the imply
 * vs clickhouse sidebar from the live `imply-readings` flag so it always
 * matches the page rendered by the lazy route components.
 */
export const TrendsSelectionsSidebar = () => {
  const implyEnabled = useImplyReadingsEnabled();
  return implyEnabled ? <SelectionsSidebar /> : <ClickhouseSelectionsSidebar />;
};

// eslint-disable-next-line react-refresh/only-export-components -- shared route helpers co-located with sidebar wrapper
export const trendsRouteBeforeLoad = () => {
  jotaiStore.set(rightPaneEnabledAtom, true);
  jotaiStore.set(rightPaneExpandedAtom, true);
  jotaiStore.set(rightPaneContentAtom, <TrendsSelectionsSidebar />);
  jotaiStore.set(rightPaneTitleAtom, 'Trends Data');
};

// eslint-disable-next-line react-refresh/only-export-components -- shared route helpers co-located with sidebar wrapper
export const trendsRouteLoader = ({ params }: { params: TrendsRouteParams }) => {
  const userState = jotaiStore.get(UserStateAtoms.user);
  const { agentId } = resolveFacilityFromParams(params, userState);

  // Seed each lane's "current chart" with the first chart in its first group.
  // Both are seeded because the active lane is decided reactively at render
  // time; setting the inactive lane is a cheap no-op that avoids any flag read
  // here in the loader.
  const firstChartId = jotaiStore.get(firstChartIdAtom);
  if (firstChartId) {
    jotaiStore.set(currentChartIdAtom, firstChartId);
  }
  const clickhouseFirstChartId = jotaiStore.get(clickhouseFirstChartIdAtom);
  if (clickhouseFirstChartId) {
    jotaiStore.set(clickhouseCurrentChartIdAtom, clickhouseFirstChartId);
  }

  return { agentId };
};
